import { Diagram, DiagramSchema } from 'models';

const defaultDiagram = (): Diagram =>
    DiagramSchema.parse({
        project: 'non-existing-but-existing',
    }) as Diagram;

export { defaultDiagram };
